module.exports = "/_next/static/images/top-b913af5b4775dff0a404451deac5b911.jpg";